/**
 * Composable для показа toast-уведомлений
 * Аналог Fluttertoast.showToast из Flutter
 */
import { reactive, readonly } from 'vue'

export interface Toast {
  id: number
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
  duration: number
}

interface ToastState {
  toasts: Toast[]
  nextId: number
}

const state = reactive<ToastState>({
  toasts: [],
  nextId: 1
})

export const useToast = () => {
  const showToast = (
    message: string,
    type: Toast['type'] = 'info',
    duration: number = 3000
  ) => {
    const id = state.nextId++
    const toast: Toast = { id, message, type, duration }
    
    state.toasts.push(toast)
    
    setTimeout(() => {
      removeToast(id)
    }, duration)
  }
  
  const removeToast = (id: number) => {
    const index = state.toasts.findIndex(t => t.id === id)
    if (index > -1) {
      state.toasts.splice(index, 1)
    }
  }
  
  const success = (message: string, duration?: number) => {
    showToast(message, 'success', duration)
  }
  
  const error = (message: string, duration?: number) => {
    showToast(message, 'error', duration)
  }
  
  const info = (message: string, duration?: number) => {
    showToast(message, 'info', duration)
  }
  
  const warning = (message: string, duration?: number) => {
    showToast(message, 'warning', duration)
  }
  
  return {
    toasts: readonly(state.toasts),
    showToast,
    removeToast,
    success,
    error,
    info,
    warning
  }
}
